module.exports = __webpack_public_path__ + "static/media/metamask.0cd3b1ad.svg";